import React from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'

import {information_data} from '../../data/aboutData'
import ParallelogramImageBox from '../../atoms/ParallelogramImageBox'

export default () => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter:{relativePath: {regex: "/about_hobby/"}}) {
        nodes {
          childImageSharp {
            fluid {
              src
            }
          }
        }
      }
    }
  `)

  const {nodes} = data.allFile
  const selectCorrectImg = (name) => {
    return nodes.filter((node) => node?.childImageSharp?.fluid?.src?.includes(name))
  }
  return (
    <Container>
      <MainTitle>Hobby</MainTitle>
      <InfoPart>
        <ParallelogramImageBox img={selectCorrectImg('about_hobby_1.png')[0].childImageSharp.fluid.src} left={-4} zIndex={1}/>
        <ParallelogramImageBox img={selectCorrectImg('about_hobby_2.png')[0].childImageSharp.fluid.src} left={8} zIndex={-1}/>
        <ListBox>
          {information_data.hobby.map((hob) => {
            return (
              <ListItem key={hob}>
                <Dash>/</Dash>{hob}
              </ListItem>
            )
          })}
        </ListBox>
      </InfoPart>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  height: 32.9rem;
  padding: 3rem 2rem;
  @media(min-width: 900px) {
    height: 43.7rem;
  }
  @media(min-width: 1100px) {
    margin: 0 auto;
    padding: 3rem 16%;
    height: 45.7rem;
  }
  @media(min-width: 1300px) {
    position: relative;
    padding: 7rem 2rem 3rem;
    padding: 4rem 21%;
    width: 100%;
    top: -3rem;
    height: 47.7rem;
  }
`
const MainTitle = styled.h2`
  width: 100%;
  color: ${props => props.theme.green};
  font-family: ELEPHNT;
  border-left: 3px solid ${props => props.theme.green};
  padding: 0 1rem;
  margin-bottom: 2rem;
  letter-spacing: 0.2rem;
  @media(min-width: 900px) {
    font-size: 2rem;
    margin-left: 3rem;
    margin-bottom: 5rem;
  }
`
const InfoPart = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  @media(min-width: 900px) {
  }
  @media(min-width: 1100px) {
  }
  @media(min-width: 1300px) {
  }
`
const ListBox = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.green};
  top: 13rem;
  padding: 1.5rem 0 1.5rem 40%;
  @media(min-width: 900px) {
    top: 17rem;
    padding: 1.5rem 0 1.5rem 40%;
  }
  @media(min-width: 1100px) {
    width: 70%;
    right: 0;
    top: 20rem;
    padding: 1.5rem 0 1.5rem 4rem;
  }
  @media(min-width: 1300px) {
    width: 50%;
    right: 14%;
    top: 24rem;
  }
`
const Dash = styled.span`
  font-size: 0.5rem;
  margin-right: 0.5rem;
  padding-left: 0.8rem;
`
const ListItem = styled.p`
  color: ${props => props.theme.beige};
  font-family: DINReg;
  margin-top: 0.5rem;
  font-weight: 100;
  font-size: 1.1rem;
  @media(min-width: 900px) {
    font-size: 1.3rem;
    margin-top: 0.7rem;
    letter-spacing: 0.2rem;
  }
`